export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";